import React, {Component} from 'react';
import {Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, Box, Stack, HStack, Text, Button, Tag} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import ConfigService from '../../../services/ConfigService';

import ImageNotFound from "../../../assets/images/ImageNotFound.png";
import { keys } from 'lodash';




export default class SlideShowModal extends Component 
{

    constructor(props)
    {
        super(props);
        this.state = {
            slides: null,
            selectedSlideIndex: 0,
            hasSlides: false,
            colorMode: "light"
        }

        this.init = this.init.bind(this);
        this.onSlide = this.onSlide.bind(this);
        this.onDownloadSelectedImage = this.onDownloadSelectedImage.bind(this);

        this.configService = new ConfigService();

    }

    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.slideFilter !== this.props.slideFilter)
        {
            if (this.props.slideFilter)
            {
                this.init();
            }
        }
    }


    init()
    {
        if ((!this.props.criteriaSlides))
        {
            this.setState({slides: [], hasSlides: false});
            return;
        }
        var rawSlides = [];
        if (this.props.slideFilter === "all")
        {
            var slideKeys = Object.keys(this.props.criteriaSlides);
            var slideArrays = slideKeys.map((k) => {return this.props.criteriaSlides[k]});
            rawSlides = slideArrays.flatMap((a) => a);
        }
        else if (this.props.slideFilter === "user")
        {
            var userImages = this.props.valueBag["userimages"] ?? [];
            // how do we convert them into what the system expects?
            rawSlides = userImages.map((img) => {
                return {
                    imgFileName: img.id + "." + img.ext,
                    title: "User Image",
                    caption: img.descript,
                    tags: img.tags.map((t) => {return t.label})
                }
            });
        }
        else
        {
            rawSlides = this.props.criteriaSlides[this.props.cardId];
        }
        if ((!rawSlides) || (rawSlides.length < 1))
        {
            this.setState({slides:[], hasSlides: false});
            return;
        }
        var basePath = (this.props.slideFilter === "user") ? this.configService.getGcidUserImageBasePath(this.props.gcid) : this.configService.getGcidSlideBasePath(this.props.gcid);
        var result = rawSlides.map((slide) =>
            {
                return {
                    "original": (slide) ? basePath + slide.imgFileName : "", 
                    "title":  slide?.title ?? "No Title", 
                    "originalAlt" : slide?.title ?? "",
                    "descript": slide?.caption ?? "", 
                    "tags": slide?.tags ?? [], 
                    "ext": slide?.imgFileName?.split('.').pop() ?? ""
                }; 
            });
        this.setState({slides: result, hasSlides: (result.length>0)})
    }
    
    onSlide(currentIndex)
    {
        this.setState({selectedSlideIndex: currentIndex});
    }

    onDownloadSelectedImage(e)
    {
        e.preventDefault();
        if (this.state.hasSlides)
        {
            var imageUrl = this.state.slides[this.state.selectedSlideIndex].original;
            fetch(imageUrl).then(response => {
                response.blob().then(blob => {
                    const fileURL = window.URL.createObjectURL(blob);
                    // Setting various property values
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = this.state.slides[this.state.selectedSlideIndex].title + "." + this.state.slides[this.state.selectedSlideIndex].ext;
                    alink.click();
                })
            });
            this.props.onToastRequest("success", "Image downloaded.");

        }
    }


    render()
    {

        return (
            <Modal isOpen={this.props?.show} onClose={() => this.props.close()}>
            <ModalOverlay />
            {((this.props.slides) && (this.state.hasSlides))} ?
            <ModalContent>
                {/*
                <ModalHeader>User-Generated Images</ModalHeader>
                <ModalCloseButton />
                */}
                <ModalBody>
                <Box rounded="20px" overflow="hidden" bg={ this.state.colorMode === "dark" ? "gray.700": "gray.200"} mt={10}>
                    <ImageGallery
                        lazyLoad={true}
                        items= {(this.state.hasSlides) ? this.state.slides : []}
                        showBullets={false}
                        showIndex={true}
                        showThumbnails={true}
                        onErrorImageURL={ImageNotFound}
                        onSlide={this.onSlide}
                    />
                    <Box p={5}>
                        <Stack align="center">
                            <Text as="h2" fontWeight="normal" my={2} >
                                {(this.state.hasSlides && this.state.slides[this.state.selectedSlideIndex].title) ? 
                                    this.state.slides[this.state.selectedSlideIndex].title : "Slide"
                                }
                            </Text>
                            <Text fontWeight="light">
                            {(this.state.hasSlides && this.state.slides[this.state.selectedSlideIndex]?.descript) ? 
                                    this.state.slides[this.state.selectedSlideIndex].descript : "No description"
                                }
                            </Text>

                            {((this.state.hasSlides) && (this.state.slides[this.state.selectedSlideIndex].tags)) &&
                            <HStack spacing={4}>
                                {this.state.slides[this.state.selectedSlideIndex]?.tags.map((tag) => <Tag size='sm' key={tag} variant='solid' colorScheme='teal'>{tag}</Tag>)}
                            </HStack>
                            }
                        </Stack>
                    </Box>
                </Box>
                </ModalBody>
                <ModalFooter>
                    <Button   
                        onClick={(e) => this.onDownloadSelectedImage(e)}
                        leftIcon={<FontAwesomeIcon icon={faDownload} />} 
                        variant='ghost'>
                        Download Image
                    </Button>
                    <Button colorScheme='blue' mr={3} onClick={() => this.props.close()}>Close</Button>
                </ModalFooter>
            </ModalContent>
            : <span/>
        </Modal>

        
        )
    }
}


